
import React from "react";
import styles from "./Partenariats.module.css";
import { PartenariatsTypes } from "@/types/displayData/PartenariatTypes";

const PartenariatsComponent: React.FC<PartenariatsTypes> = ({ title, subtitle, description, partners }) => {
  return (
    <section className={styles.partenariatsContainer}>
      <h2 className={styles.partenariatsTitle}>{title}</h2>
      <h3 className={styles.partenariatsSubtitle}>{subtitle}</h3>
      <p className={styles.partenariatsDescription}>{description}</p>

      <div className={styles.partnersContainer}>
        {partners.map((partner, index) => (
          <div key={index} className={styles.partner}>
            <img src={partner.logo} alt={partner.name} className={styles.partnerLogo} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default PartenariatsComponent;
